import { Box } from "@mui/material";

import { MenuLinks } from "./MenuLinks";
import { ThemeSwitch } from "./ThemeSwitch";

export const DesktopMenu = () => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: ".5rem",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          gap: ".5rem",
        }}
      >
        <MenuLinks />
      </Box>

      <ThemeSwitch />
    </Box>
  );
};
